React = require 'react'
t = require('views/internal/recup-with-helpers')('home_up_next')
Util = require 'lib/util'
moment = require 'moment'
Auth = require 'db/auth'
CanonicalCommentInlineReply = require 'views/canonical-comment/canonical-comment-inline-reply'

{ Avatar } = require '@atlassian/trello-canonical-components/canonical-card'

{
  CommentActions
  CommentContainer
  CommentInfo
  CommentText
  Header
  IconButton
} = require '@atlassian/trello-canonical-components/canonical-comment'

replyIcon = require 'images/canonical-comment/send-icon.svg'
dismissIcon = require 'images/canonical-comment/dismiss-icon.svg'
completeIcon = require 'images/canonical-comment/complete-icon.svg'

module.exports = class HomeUpNextCardInfoCompenent extends React.Component
  displayName: 'HomeUpNextCardInfoCompenent'

  render: t.renderable ->
    {
      board
      date
      isEdited
      memberCreator
      actionMemberCreator
      comment
      isAddMemberToCard
      dueSoon
      canReply
      dueDate
      isReplying
      replyMessage
      onChangeReplyMessage
      onReplyClick
      onCancelClick
      onSaveClick
      onDismissClick
      onCompleteClick
    } = @props

    avatarHash = actionMemberCreator?.get('avatarHash')

    t.div =>
      t.div '.canonical-comment', =>
        t.tag CommentContainer, =>
          t.tag Header, =>
            if dueDate && dueSoon
              t.div '.text-snippet-icons-container', ->
                t.span { class: 'text-snippet-icon icon-lg icon-clock' }
              t.span '.text-snippet', ->
                t.format 'due'
                t.text ' '
                t.span '.date', { 'data-date': dueDate }

            else if actionMemberCreator
              t.tag Avatar, {
                key: actionMemberCreator.id
                deactivated: actionMemberCreator?.get('isDeactivated')
                img: avatarHash and [window.avatarDomain, avatarHash, '30.png'].join('/')
                img2x: avatarHash and [window.avatarDomain, avatarHash, '50.png'].join('/')
                initials: actionMemberCreator?.get('initials')
                lightBackground: true
              }

              if date
                name = actionMemberCreator?.get('fullName')

                if isAddMemberToCard
                  if Auth.isMe(actionMemberCreator)
                    name = t.l('you-added-yourself-to-card')
                  else
                    name = t.l('user-added-you-to-card', { actionMemberCreatorName: actionMemberCreator?.get('fullName') }, { raw: true })

                t.tag CommentInfo, {
                  name: name
                  date: if isEdited then "#{moment(date).fromNow()} #{t.l('edited')}" else moment(date).fromNow()
                }

          if comment
            t.tag CommentText, =>
              t.raw comment

          t.tag CommentActions, =>
            if canReply
              t.tag IconButton, {
                icon: replyIcon
                onClick: onReplyClick
                className: 'canonical-comment-icon-button'
              }, =>
                t.format 'reply'

            if dueDate && dueSoon
              t.tag IconButton, {
                icon: completeIcon
                onClick: onCompleteClick
                className: 'canonical-comment-icon-button'
              }, =>
                t.format 'complete'

            t.tag IconButton, {
              icon: dismissIcon
              onClick: onDismissClick
              className: 'canonical-comment-icon-button'
            }, =>
              t.format 'dismiss'

      if isReplying
        t.tag CanonicalCommentInlineReply, {
          memberCreator
          onSaveClick
          onCancelClick
          isReplying
          replyMessage
          onChangeReplyMessage
        }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-up-next-card-info-component.coffee